import { Routes } from '@angular/router';

export const REGIONS_ROUTES: Routes = [
  {
    path: 'regions',
    loadComponent: () =>
      import('./regions-list/regions-list.component')
        .then(m => m.RegionsListComponent),
  }
];
